import React, { ChangeEvent } from 'react';

import clsx from 'clsx';
import { Checkbox as CheckboxMui, FormControlLabel } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

import { CheckboxType } from './checkbox.enums';
import styles from './Checkbox.module.scss';

interface CheckboxProps {
  label?: string | React.ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  errorMessage?: string;
  type?: CheckboxType;
  isChecked?: boolean;
  disabled?: boolean;
  className?: string;
}

const Checkbox = ({
  label,
  onChange,
  name,
  errorMessage,
  type = CheckboxType.Primary,
  isChecked = false,
  disabled = false,
  className,
}: CheckboxProps) => {
  const [checked, setChecked] = React.useState(isChecked);
  const checkedClassName = clsx({
    [styles.primaryType]: type === CheckboxType.Primary && !disabled,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    onChange(event);
  };

  return (
    <>
      <FormControlLabel
        classes={{ label: styles.checkBoxLabel, root: className }}
        control={
          <CheckboxMui
            classes={{ root: styles.checkboxRoot, checked: checkedClassName }}
            checkedIcon={<CheckBoxOutlinedIcon />}
            onChange={handleChange}
            name={name}
            checked={checked}
            disabled={disabled}
          />
        }
        label={label}
      />
      {errorMessage && <p className={styles.errorNotification}>{errorMessage}</p>}
    </>
  );
};

export default Checkbox;
